import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { ITextValue } from '../../interfaces/text-value.interface';
import { INumericValue } from '../../interfaces/numeric-value.interface';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';

export class SmtElecMeasServerPlugin extends SmartenitPlugin
  implements ITextValue, INumericValue {
  private supportsEnergyUsage: boolean = false;
  public static OPERATION_MODES = [
    { mode: 0, name: 'SINGLE_PHASE_6_CHANNEL' },
    { mode: 2, name: 'SPLIT_PHASE_6_CHANNEL' },
    { mode: 4, name: '3_PHASE_2_CHANNEL_4_WIRE' },
    { mode: 5, name: '3_PHASE_2_CHANNEL_3_WIRE' }
  ];

  public getReportableAttrs() {
    return ['ActivePower', 'SummationDelivered'];
  }

  public getUnit(attribute?: string): string {
    let response: string = '';

    switch (attribute) {
      case 'ActivePower':
        response = 'kW';
        break;
      case 'SummationDelivered':
        response = 'kWh';
        break;
    }

    return response;
  }

  public getTotalActivePower(): string {
    return this.state.totalActivePower != null
      ? !isNaN(Number(this.state.totalActivePower))
        ? Number(this.state.totalActivePower / 100).toFixed(2)
        : '--'
      : '--';
  }

  public getOperationMode(q = '') {
    this.getAttributeWithSubscribeOption(this.componentId, this.processorName, 'MeterConfig', {}, true, q);
  }

  public setOperationMode(mode: number) {
    if (SmtElecMeasServerPlugin.OPERATION_MODES.find((op) => op.mode === mode)) {
      return this.setAttributeWithSubscribeOption(this.componentId, this.processorName, 'MeterConfig', { value: mode }, true);
    } else {
      return null;
    }
  }

  public getTotalSummationDelivered(): string {
    return this.getSummationDelivered() != null && this.getSummationDeliveredPhB() != null && this.getSummationDeliveredPhC() != null
      ? !isNaN(Number(this.getSummationDelivered())) && !isNaN(Number(this.getSummationDeliveredPhB()))
        && !isNaN(Number(this.getSummationDeliveredPhC()))
        ? ((Number(this.getSummationDelivered()) + Number(this.getSummationDeliveredPhB()) + Number(this.getSummationDeliveredPhC()))).toFixed(2)
        : '--'
      : '--';
  }

  public getTotalActivePowerPhases(): string {
    return this.getActivePower() != null && this.getActivePowerPhB() != null && this.getActivePowerPhC() != null
      ? !isNaN(Number(this.getActivePower())) && !isNaN(Number(this.getActivePowerPhB()))
        && !isNaN(Number(this.getActivePowerPhC()))
        ? ((Number(this.getActivePower()) + Number(this.getActivePowerPhB()) + Number(this.getActivePowerPhC()))).toFixed(2)
        : '--'
      : '--';
  }

  public getActivePower(): string {
    return this.state.activePower != null && this.state.acPowerMultiplier != null && this.state.acPowerDivisor != null
      ? !isNaN(Number(this.state.activePower)) && !isNaN(Number(this.state.acPowerMultiplier)) && !isNaN(Number(this.state.acPowerDivisor))
        ? ((this.state.activePower * (this.state.acPowerMultiplier / this.state.acPowerDivisor)) / 1000).toFixed(2)
        : '--'
      : '--';
  }

  public getActivePowerPhB(): string {
    return this.state.activePowerPhB != null && this.state.acPowerMultiplier != null && this.state.acPowerDivisor != null
      ? !isNaN(Number(this.state.activePowerPhB)) && !isNaN(Number(this.state.acPowerMultiplier)) && !isNaN(Number(this.state.acPowerDivisor))
        ? ((this.state.activePowerPhB * (this.state.acPowerMultiplier / this.state.acPowerDivisor)) / 1000).toFixed(2)
        : '--'
      : '--';
  }

  public getActivePowerPhC(): string {
    return this.state.activePowerPhC != null && this.state.acPowerMultiplier != null && this.state.acPowerDivisor != null
      ? !isNaN(Number(this.state.activePowerPhC)) && !isNaN(Number(this.state.acPowerMultiplier)) && !isNaN(Number(this.state.acPowerDivisor))
        ? ((this.state.activePowerPhC * (this.state.acPowerMultiplier / this.state.acPowerDivisor)) / 1000).toFixed(2)
        : '--'
      : '--';
  }

  public getSummationDelivered(): string {
    return this.state.summationDelivered != null && this.state.summationDeliveredMultiplier != null && this.state.summationDeliveredDivisor != null
      ? !isNaN(Number(this.state.summationDelivered)) && !isNaN(Number(this.state.summationDeliveredMultiplier))
        && !isNaN(Number(this.state.summationDeliveredDivisor))
        ? (((this.state.summationDelivered * (this.state.summationDeliveredMultiplier / this.state.summationDeliveredDivisor)) / 1000)
          .toFixed(3)).toString()
        : '--'
      : '--';
  }

  public getSummationDeliveredPhB(): string {
    return this.state.summationDeliveredPhB != null && this.state.summationDeliveredMultiplier != null && this.state.summationDeliveredDivisor != null
      ? !isNaN(Number(this.state.summationDeliveredPhB)) && !isNaN(Number(this.state.summationDeliveredMultiplier))
        && !isNaN(Number(this.state.summationDeliveredDivisor))
        ? (((this.state.summationDeliveredPhB * (this.state.summationDeliveredMultiplier / this.state.summationDeliveredDivisor)) / 1000)
          .toFixed(3)).toString()
        : '--'
      : '--';
  }

  public getSummationDeliveredPhC(): string {
    return this.state.summationDeliveredPhC != null && this.state.summationDeliveredMultiplier != null && this.state.summationDeliveredDivisor != null
      ? !isNaN(Number(this.state.summationDeliveredPhC)) && !isNaN(Number(this.state.summationDeliveredMultiplier))
        && !isNaN(Number(this.state.summationDeliveredDivisor))
        ? (((this.state.summationDeliveredPhC * (this.state.summationDeliveredMultiplier / this.state.summationDeliveredDivisor)) / 1000)
          .toFixed(3)).toString()
        : '--'
      : '--';
  }

  public getValue(attribute?: string): number {
    let response: number = 0;

    switch (attribute) {
      case 'TotalActivePower':
        response = this.state.totalActivePower != null
          ? !isNaN(Number(this.state.totalActivePower))
            ? (this.state.totalActivePower).toFixed(3)
            : 0
          : 0;
        break;
      case 'TotalSummationDelivered':
        response = this.getSummationDelivered() != null && this.getSummationDeliveredPhB() != null && this.getSummationDeliveredPhC() != null
          ? !isNaN(Number(this.getSummationDelivered())) && !isNaN(Number(this.getSummationDeliveredPhB()))
            && !isNaN(Number(this.getSummationDeliveredPhC()))
            ? Number(Number(this.getSummationDelivered()).toFixed(3) + Number(this.getSummationDeliveredPhB()).toFixed(3)
              + Number(this.getSummationDeliveredPhC()).toFixed(3))
            : 0
          : 0;
        break;
      case 'ActivePower':
        response = this.state.activePower != null && this.state.acPowerMultiplier != null
          && this.state.acPowerDivisor != null
          ? !isNaN(Number(this.state.activePower)) && !isNaN(Number(this.state.acPowerMultiplier))
            && !isNaN(Number(this.state.acPowerDivisor))
            ? Number(((this.state.activePower * (this.state.acPowerMultiplier / this.state.acPowerDivisor)) / 1000)
              .toFixed(3))
            : 0
          : 0;
        break;
      case 'SummationDelivered':
        response = this.state.summationDelivered != null && this.state.summationDeliveredMultiplier != null
          && this.state.summationDeliveredDivisor != null
          ? !isNaN(Number(this.state.summationDelivered)) && !isNaN(Number(this.state.summationDeliveredMultiplier))
            && !isNaN(Number(this.state.summationDeliveredDivisor))
            ? Number(((this.state.summationDelivered * (this.state.summationDeliveredMultiplier / this.state.summationDeliveredDivisor)) / 1000)
              .toFixed(3))
            : 0
          : 0;
        break;

      case 'getActivePowerPhB':
        response = this.state.activePowerPhB != null && this.state.acPowerMultiplier != null && this.state.acPowerDivisor != null
          ? !isNaN(Number(this.state.activePowerPhB)) && !isNaN(Number(this.state.acPowerMultiplier)) && !isNaN(Number(this.state.acPowerDivisor))
            ? Number(((this.state.activePowerPhB * (this.state.acPowerMultiplier / this.state.acPowerDivisor)) / 1000).toFixed(2))
            : 0
          : 0;
        break;

      case 'SummationDeliveredPhB':
        response = this.state.summationDeliveredPhB != null && this.state.summationDeliveredMultiplier != null
          && this.state.summationDeliveredDivisor != null
          ? !isNaN(Number(this.state.summationDeliveredPhB)) && !isNaN(Number(this.state.summationDeliveredMultiplier))
            && !isNaN(Number(this.state.summationDeliveredDivisor))
            ? Number(((this.state.summationDeliveredPhB * (this.state.summationDeliveredMultiplier / this.state.summationDeliveredDivisor)) / 1000)
              .toFixed(3))
            : 0
          : 0;
        break;

      case 'ActivePowerPhC':
        response = this.state.activePowerPhC != null && this.state.acPowerMultiplier != null && this.state.acPowerDivisor != null
          ? !isNaN(Number(this.state.activePowerPhC)) && !isNaN(Number(this.state.acPowerMultiplier)) && !isNaN(Number(this.state.acPowerDivisor))
            ? Number(((this.state.activePowerPhC * (this.state.acPowerMultiplier / this.state.acPowerDivisor)) / 1000).toFixed(2))
            : 0
          : 0;
        break;

      case 'SummationDeliveredPhC':
        response = this.state.summationDeliveredPhC != null && this.state.summationDeliveredMultiplier != null
          && this.state.summationDeliveredDivisor != null
          ? !isNaN(Number(this.state.summationDeliveredPhC)) && !isNaN(Number(this.state.summationDeliveredMultiplier))
            && !isNaN(Number(this.state.summationDeliveredDivisor))
            ? Number(((this.state.summationDeliveredPhC * (this.state.summationDeliveredMultiplier / this.state.summationDeliveredDivisor)) / 1000)
              .toFixed(3))
            : 0
          : 0;
        break;
    }

    return response;
  }

  public getConditionAttribute(): string {
    // return this by default but client can choose the attribute from JSON
    return 'ActivePower';
  }

  public getConditionOptions(): any {
    return null;
  }

  public getEffectOptions(): any {
    return null;
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }

  public setValue(value: number, attribute?: string, subscribe?: boolean): any {
    // Do nothing becase values are read only

    if (subscribe) {
      return Observable.of(true);
    }

    return true;
  }

  public getTextValue(context?: string): string {
    if (context && context == 'displayActivePowerOnly') {
      return this.getActivePower() + this.getUnit('ActivePower');
    } else if (context && context == 'displayTotalValues') {
      return `${this.getTotalActivePower()} kW / ${this.getSummationDelivered()} kWh`;
    } else if (context && context == 'displayPhaseA') {
      return `${this.getActivePower()} kW / ${this.getSummationDelivered()} kWh`;
    } else if (context && context == 'displayPhaseB') {
      return `${this.getActivePowerPhB()} kW / ${this.getSummationDeliveredPhB()} kWh`;
    } else if (context && context == 'displayPhaseC') {
      return `${this.getActivePowerPhC()} kW / ${this.getSummationDeliveredPhC()} kWh`;
    } else {
      if (this.supportsEnergyUsage) {
        /* Pending check if metrics supported*/
        // const Summation = `${this.getSummationDelivered()}${'kWh'}`;
        // const Power = `${this.getActivePower()}${'W'}`;
        // return `{{CURRENCY}}${this.getPeriodCost()} / ${periodSummation} / ${instDemand}`;
      } else {
        return `${this.getActivePower()} kW / ${this.getSummationDelivered()} kWh`;
      }
    }
    return '';
  }

  public formatValue(value: string): string {
    return value;
  }

  public getStatusPayload(): any {
    return [
      'ActivePower',
      'ActivePowerPhB',
      'ActivePowerPhC',
      'TotalActivePower',
      'SummationDelivered',
      'SummationDeliveredPhB',
      'SummationDeliveredPhC',
      'ACPowerMultiplier',
      'ACPowerDivisor',
      'SummationDeliveredMultiplier',
      'SummationDeliveredDivisor',
      'MeterConfig',
      'CtSelection',
      // 'ACFrequencyMultiplier',
      // 'ACFrequencyDivisor',
      // 'ACVoltageMultiplier',
      // 'ACVoltageDivisor',
      // 'ACCurrentMultiplier',
      // 'ACCurrentDivisor',
      // 'ACFrequency',
      // 'RMSVoltage',
      // 'RMSCurrent',
      // 'PowerFactor',
      // 'RMSVoltagePhB',
      // 'RMSVoltagePhC'
    ];
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;
    if (attribute === 'CtSelection') {
      this.state.ctSelection = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'RMSVoltagePhB') {
      this.state.rmsVoltagePhB = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'RMSVoltagePhC') {
      this.state.rmsVoltagePhC = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'MeterConfig') {
      this.state.meterConfig = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ActivePower') {
      this.state.activePower = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ActivePowerPhB') {
      this.state.activePowerPhB = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ActivePowerPhC') {
      this.state.activePowerPhC = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'TotalActivePower') {
      this.state.totalActivePower = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'SummationDelivered') {
      this.state.summationDelivered = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'SummationDeliveredPhB') {
      this.state.summationDeliveredPhB = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'SummationDeliveredPhC') {
      this.state.summationDeliveredPhC = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACFrequencyMultiplier') {
      this.state.acFrequencyMultiplier = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACFrequencyDivisor') {
      this.state.acFrequencyDivisor = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACVoltageMultiplier') {
      this.state.acVoltageMultiplier = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACVoltageDivisor') {
      this.state.acVoltageDivisor = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACCurrentMultiplier') {
      this.state.acCurrentMultiplier = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACCurrentDivisor') {
      this.state.acCurrentDivisor = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACPowerMultiplier') {
      this.state.acPowerMultiplier = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACPowerDivisor') {
      this.state.acPowerDivisor = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'SummationDeliveredMultiplier') {
      this.state.summationDeliveredMultiplier = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'SummationDeliveredDivisor') {
      this.state.summationDeliveredDivisor = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'PowerFactor') {
      this.state.powerFactor = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'RMSCurrent') {
      this.state.rmsCurrent = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'RMSVoltage') {
      this.state.rmsVoltage = response.value;
      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ACFrequency') {
      this.state.acFrequency = response.value;
      this._onUpdate.next({ state: this.state });
    }

    return this.state;
  }
}
